module.exports = __webpack_public_path__ + "static/media/Need Help Icon4.e5ffdc1a.svg";